var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClinicsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.156,
    height: 19.151,
    viewBox: "0 0 19.156 19.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 19.156,
    height: 19.151,
    fill: "#1ebcc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16664",
    "data-name": "Group 16664",
    transform: "translate(4752 786.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16040",
    "data-name": "Group 16040",
    transform: "translate(-4752 -786.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15125",
    "data-name": "Group 15125",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41138",
    "data-name": "Path 41138",
    d: "M13.217,154.9c0-.948,0-1.865,0-2.782a.274.274,0,0,1,.428-.237c1.08.681,2.179,1.334,3.236,2.049a4.962,4.962,0,0,1,2.245,3.792c.058.617.009,1.244.009,1.88H0c0-.453-.013-.907,0-1.359a6.346,6.346,0,0,1,.1-1.02,5.148,5.148,0,0,1,2.408-3.453l3.007-1.888a.259.259,0,0,1,.411.227c0,.025,0,.05,0,.075,0,.88,0,1.759,0,2.639a.253.253,0,0,1-.173.278,1.671,1.671,0,0,0-.928,1.908,1.684,1.684,0,0,0,3.277,0,1.67,1.67,0,0,0-.88-1.882.277.277,0,0,1-.184-.294c.009-.617,0-1.235,0-1.853v-.2a7.666,7.666,0,0,0,5.028.012V154.9c-.218,0-.428,0-.638,0a1.313,1.313,0,0,0-1.336,1.339c0,.312,0,.624,0,.936a.936.936,0,0,0,.937.942c.187,0,.374.005.561,0A.56.56,0,1,0,11.6,157c-.117,0-.234,0-.37,0,0-.276-.013-.537.009-.8a.266.266,0,0,1,.194-.171c.786-.012,1.572-.008,2.358-.007a.183.183,0,0,1,.206.193c.005.254,0,.508,0,.781-.134,0-.251,0-.367,0a.56.56,0,1,0,.006,1.121c.181,0,.362,0,.543,0a.9.9,0,0,0,.92-.791,6.4,6.4,0,0,0-.021-1.379,1.252,1.252,0,0,0-1.235-1.047c-.2,0-.409,0-.632,0",
    transform: "translate(0 -140.455)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41139",
    "data-name": "Path 41139",
    d: "M81.19,5.721H72.955v-.2q0-1.619,0-3.237A2.244,2.244,0,0,1,75.241,0h3.63A2.243,2.243,0,0,1,81.19,2.325q0,1.59,0,3.181v.215M77.634,3.706c.14,0,.252,0,.363,0a.561.561,0,1,0,0-1.121c-.117,0-.234,0-.368,0,0-.135,0-.252,0-.368a.561.561,0,1,0-1.121,0c0,.116,0,.233,0,.364-.132,0-.243,0-.354,0a.561.561,0,1,0-.005,1.121c.116,0,.232,0,.359,0,0,.142,0,.26,0,.377a.56.56,0,1,0,1.121,0c0-.117,0-.234,0-.373",
    transform: "translate(-67.486 0)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41140",
    "data-name": "Path 41140",
    d: "M80.771,91.512a7.091,7.091,0,0,1-.218,2.4,3.592,3.592,0,0,1-3.35,2.344,15.2,15.2,0,0,1-1.55-.038A3.5,3.5,0,0,1,72.621,93.4a17.56,17.56,0,0,1-.12-1.891Z",
    transform: "translate(-67.066 -84.652)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41141",
    "data-name": "Path 41141",
    d: "M79.519,209.339a.562.562,0,1,1,.554-.564.568.568,0,0,1-.554.564",
    transform: "translate(-73.032 -192.607)",
    fill: "#1ebcc2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicsIcon);
export default __webpack_public_path__ + "static/media/clinics_icon.492d8f606e0684c923479404d5c8905e.svg";
export { ForwardRef as ReactComponent };